/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('oauth.signup', {
      url: '/signup?code&app&username&password&continue&type&state&client_id&message&membershipType&membershipAmount&utm_source&utm_campaign&utm_medium&original_source&gcl_id&referrer&first_visit&post_login_page&collect_coupon&from_domain&referral_code',
      template: '<sign-up></sign-up>',
      data: { pageTitle: 'Sign-Up for Free | ShoppRe™️ | Ship Internationally from India' },
    });
}



// WEBPACK FOOTER //
// ./client/app/oauth/sign-up/sign-up.routes.js